import { defaultCatalogPolicy } from "@KassaroAB/shared/types/catalogPolicy";
import { CatalogDomain } from "@KassaroAB/shared/types/enums/CatalogDomain";
import { resolveDomainPolicy } from "@KassaroAB/shared/utils/catalogPolicy";
import type { CatalogScope } from "../api/catalogScope";
import { useGetChainQuery } from "../query/chainsQuery";
import { useGetStoreQuery } from "../query/storesQuery";

export type ProductImportAccess =
  | "chain"
  | "store"
  | "storeScoped"
  | "locked"
  | "unknown";

export const useProductImportAccess = (
  scope: CatalogScope | null
): ProductImportAccess => {
  const storeId = scope?.type === "store" ? scope.id : undefined;
  const { data: store } = useGetStoreQuery(storeId);
  const { data: chain } = useGetChainQuery(store?.chainId);

  if (scope?.type === "chain") {
    return "chain";
  }
  if (!store || !chain) {
    return "unknown";
  }
  if (chain.chainMode !== true) {
    return "store";
  }
  const productPolicy = resolveDomainPolicy(
    chain.catalogPolicy ?? defaultCatalogPolicy,
    store.catalogPolicyOverrides,
    CatalogDomain.PRODUCTS
  );
  return productPolicy.storesCanCreateLocal === false ? "locked" : "storeScoped";
};
